import {Component, inject, OnInit, signal} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {DataService} from "../services/data.service";
import {ToastrService} from "ngx-toastr";
import moment from "moment";

@Component({
    selector: 'app-report',
    imports: [FormsModule],
    template: `
        <div class="card">
            <div class="card-body">
                <div class="mb-4">
                    <h3><i class="fa-solid fa-file-pdf me-2"></i>Berichte</h3>
                </div>

                <!-- Report Type Selection Cards -->
                <div class="row mb-4">
                    <div class="col-md">
                        <div class="card h-100 cursor-pointer"
                             [class.border-primary]="selectedReportType === 'store'"
                             [class.bg-primary]="selectedReportType === 'store'"
                             [class.bg-opacity-10]="selectedReportType === 'store'"
                             [style.border-width]="selectedReportType === 'store' ? '3px' : '1px'"
                             (click)="selectReportType('store')" style="cursor: pointer;">
                            <div class="card-body text-center" [class.text-primary]="selectedReportType === 'store'">
                                <i class="fa-solid fa-store fa-3x mb-3"></i>
                                <h5 class="card-title mb-0">Store Performance History</h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md">
                        <div class="card h-100 cursor-pointer"
                             [class.border-primary]="selectedReportType === 'monthly_store'"
                             [class.bg-primary]="selectedReportType === 'monthly_store'"
                             [class.bg-opacity-10]="selectedReportType === 'monthly_store'"
                             [style.border-width]="selectedReportType === 'monthly_store' ? '3px' : '1px'"
                             (click)="selectReportType('monthly_store')" style="cursor: pointer;">
                            <div class="card-body text-center" [class.text-primary]="selectedReportType === 'monthly_store'">
                                <i class="fa-solid fa-store fa-3x mb-3"></i>
                                <h5 class="card-title mb-0">Monatsbericht Store</h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md">
                        <div class="card h-100 cursor-pointer"
                             [class.border-primary]="selectedReportType === 'monthly'"
                             [class.bg-primary]="selectedReportType === 'monthly'"
                             [class.bg-opacity-10]="selectedReportType === 'monthly'"
                             [style.border-width]="selectedReportType === 'monthly' ? '3px' : '1px'"
                             (click)="selectReportType('monthly')" style="cursor: pointer;">
                            <div class="card-body text-center" [class.text-primary]="selectedReportType === 'monthly'">
                                <i class="fa-solid fa-calendar-days fa-3x mb-3"></i>
                                <h5 class="card-title mb-0">Monatsbericht</h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md">
                        <div class="card h-100 cursor-pointer"
                             [class.border-primary]="selectedReportType === 'quarterly'"
                             [class.bg-primary]="selectedReportType === 'quarterly'"
                             [class.bg-opacity-10]="selectedReportType === 'quarterly'"
                             [style.border-width]="selectedReportType === 'quarterly' ? '3px' : '1px'"
                             (click)="selectReportType('quarterly')" style="cursor: pointer;">
                            <div class="card-body text-center" [class.text-primary]="selectedReportType === 'quarterly'">
                                <i class="fa-solid fa-calendar-week fa-3x mb-3"></i>
                                <h5 class="card-title mb-0">Quartalsbericht</h5>
                            </div>
                        </div>
                    </div>
                    <div class="col-md">
                        <div class="card h-100 cursor-pointer"
                             [class.border-primary]="selectedReportType === 'yearly'"
                             [class.bg-primary]="selectedReportType === 'yearly'"
                             [class.bg-opacity-10]="selectedReportType === 'yearly'"
                             [style.border-width]="selectedReportType === 'yearly' ? '3px' : '1px'"
                             (click)="selectReportType('yearly')" style="cursor: pointer;">
                            <div class="card-body text-center" [class.text-primary]="selectedReportType === 'yearly'">
                                <i class="fa-solid fa-calendar fa-3x mb-3"></i>
                                <h5 class="card-title mb-0">Jahresbericht</h5>
                            </div>
                        </div>
                    </div>
                </div>

                @if (selectedReportType) {
                    <div class="mt-4">
                        <div class="d-flex flex-wrap align-items-center gap-3">
                            <!-- Store Selection (only for Storebericht und Monatsbericht Store) -->
                            @if (selectedReportType === 'store' || selectedReportType === 'monthly_store') {
                                <select class="form-control" style="width: 200px" [(ngModel)]="id_store">
                                    @if (selectedReportType === 'monthly_store') {
                                        <option value="all">Alle Stores</option>
                                    }
                                    @for (store of stores; track store.id) {
                                        <option [value]="store.id">{{ store.name }}</option>
                                    }
                                </select>
                            }

                            @if (selectedReportType !== 'store') {
                                <!-- Year Selection (for all types) -->
                                <div class="input-group" style="width: 170px">
                                    <div class="input-group-prepend">
                                        <button class="btn btn-outline-secondary" type="button" (click)="setYear(-1)">
                                            <i class="fa-solid fa-arrow-left"></i>
                                        </button>
                                    </div>
                                    <input type="number" class="form-control"
                                           [(ngModel)]="year"
                                           [max]="currentYear"/>
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-secondary" type="button" [disabled]="year == currentYear" (click)="setYear(1)">
                                            <i class="fa-solid fa-arrow-right"></i>
                                        </button>
                                    </div>
                                </div>
                            }

                            <!-- Month Selection (for Monatsbericht Store and Monatsbericht) -->
                            @if (selectedReportType === 'monthly_store' || selectedReportType === 'monthly') {
                                <select class="form-control" style="width: 150px" [(ngModel)]="month">
                                    @for (monthName of monthNames; track $index; let i = $index) {
                                        <option [value]="i">{{ monthName }}</option>
                                    }
                                </select>
                            }

                            <!-- Quarter Selection (only for Quartalsbericht) -->
                            @if (selectedReportType === 'quarterly') {
                                <select class="form-control" style="width: 150px" [(ngModel)]="quarter">
                                    <option [value]="1">Quartal 1</option>
                                    <option [value]="2">Quartal 2</option>
                                    <option [value]="3">Quartal 3</option>
                                    <option [value]="4">Quartal 4</option>
                                </select>
                            }
                        </div>

                        <!-- Create Report Button -->
                        <div class="mt-4">
                            <button type="button" class="btn btn-primary btn-lg"
                                    [disabled]="selectedReportType === 'store' && (!id_store) || loading()"
                                    (click)="createReport()">
                                <i class="fa-solid fa-file-pdf me-2"></i>Bericht erstellen
                                @if (loading()) {
                                    <i class="fa fa-spinner fa-spin ms-2"></i>
                                }
                            </button>
                        </div>
                    </div>
                } @else {
                    <h4 class="text-muted">Bitte Berichtart auswählen</h4>
                }
            </div>
        </div>
    `
})
export class ReportComponent implements OnInit {

    private dataService = inject(DataService);
    private toastrService = inject(ToastrService);

    loading = signal<boolean>(false);

    users: any[] = []
    recipients: any[] = [];

    stores!: any[];
    id_store = 'all';

    year: any;
    currentYear!: number;
    month: any;
    currentMonth!: number;
    quarter: any;

    selectedReportType: 'store' | 'monthly_store' | 'monthly' | 'quarterly' | 'yearly' | null = null;

    monthNames = [
        'Jänner', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'
    ];

    ngOnInit(): void {
        this.currentYear = moment().year();
        this.currentMonth = moment().month();
        this.year = moment().year();
        this.month = moment().month();
        this.quarter = moment().quarter();

        this.dataService.request("User/listWithPhoneNumber").subscribe(response => {
            this.users = response.users;
        });

        this.dataService.request("Store/listForSelection").subscribe(response => {
            this.stores = response.stores;
        })
    }

    sendSMS() {
        if (this.recipients.length == 0) return;

        this.dataService.request("Report/sendSMS", {
            recipients: this.recipients,
        }).subscribe(response => {
            this.toastrService.success("Die SMS wurde versandt!");
        });
    }

    createYearlyReport() {
        this.dataService.request("Data/createYearlyReport", {
            id_store: this.id_store,
            year: this.year,
        }).subscribe(response => {
            this.loading.set(false);

            if (response?.pdf) {
                const byteCharacters = atob(response.pdf);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: 'application/pdf'});
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
                // Optionally revoke after some delay
                setTimeout(() => URL.revokeObjectURL(url), 60000);
            }
        });
    }

    createMonthlyReport() {
        this.dataService.request("Data/createMonthlyReport", {
            year: this.year,
            month: this.month,
        }).subscribe(response => {
            this.loading.set(false);

            if (response?.pdf) {
                const byteCharacters = atob(response.pdf);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: 'application/pdf'});
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
                // Optionally revoke after some delay
                setTimeout(() => URL.revokeObjectURL(url), 60000);
            }
        });
    }

    createQuarterlyReport() {
        this.dataService.request("Data/createQuarterlyReport", {
            id_store: this.id_store,
            year: this.year,
            quarter: this.quarter,
        }).subscribe(response => {
            this.loading.set(false);

            if (response?.pdf) {
                const byteCharacters = atob(response.pdf);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: 'application/pdf'});
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
                // Optionally revoke after some delay
                setTimeout(() => URL.revokeObjectURL(url), 60000);
            }
        });
    }

    createMonthlyStoreReport() {
        this.dataService.request("Data/createMonthlyStoreReport", {
            id_store: this.id_store,
            year: this.year,
            month: this.month,
        }).subscribe(response => {
            this.loading.set(false);

            if (response?.pdf) {
                const byteCharacters = atob(response.pdf);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: 'application/pdf'});
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
                // Optionally revoke after some delay
                setTimeout(() => URL.revokeObjectURL(url), 60000);
            } else if (response?.zip && response?.filename) {
                const byteCharacters = atob(response.zip);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: 'application/zip'});
                const url = URL.createObjectURL(blob);

                // Create a temporary download link and trigger it
                const a = document.createElement('a');
                a.href = url;
                a.download = response.filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                // Revoke the URL after a short delay
                setTimeout(() => URL.revokeObjectURL(url), 100);
            }
        });
    }

    createStoreReport() {
        this.dataService.request("Data/createStoreReport", {
            id_store: this.id_store,
        }).subscribe(response => {
            this.loading.set(false);

            if (response?.pdf) {
                const byteCharacters = atob(response.pdf);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: 'application/pdf'});
                const url = URL.createObjectURL(blob);
                window.open(url, '_blank');
                // Optionally revoke after some delay
                setTimeout(() => URL.revokeObjectURL(url), 60000);
            } else if (response?.zip && response?.filename) {
                const byteCharacters = atob(response.zip);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: 'application/zip'});
                const url = URL.createObjectURL(blob);

                // Create a temporary download link and trigger it
                const a = document.createElement('a');
                a.href = url;
                a.download = response.filename;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                // Revoke the URL after a short delay
                setTimeout(() => URL.revokeObjectURL(url), 100);
            }
        });
    }

    setYear(number: number) {
        this.year += number;

        if (this.year == this.currentYear && this.month >= this.currentMonth) {
            this.month = this.currentMonth;
        }
    }

    selectReportType(type: 'store' | 'monthly_store' | 'monthly' | 'quarterly' | 'yearly') {
        this.selectedReportType = type;
        if (type === 'store' && this.id_store === 'all') {
            this.id_store = this.stores[0].id;
        }
    }

    createReport() {
        this.loading.set(true);
        if (this.selectedReportType === 'store') {
            this.createStoreReport();
        } else if (this.selectedReportType === 'monthly_store') {
            this.createMonthlyStoreReport();
        } else if (this.selectedReportType === 'monthly') {
            this.createMonthlyReport();
        } else if (this.selectedReportType === 'quarterly') {
            this.createQuarterlyReport();
        } else if (this.selectedReportType === 'yearly') {
            this.createYearlyReport();
        }
    }
}
